import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import className from "classnames"
import { Switch, message, Select, Input } from "antd"
import { addSku } from '../../../services/api/apiSku'
import checkValidate from './../helper/checkValidate'
import getHistory from '../../../getHistory'

class AddNewModal extends Component {
    state = {
        name: '',
        sku: '',
        status: false,
        procedure: '2D',
        loading: false,
        export_by: '',
        error: '',
        validated: false,
        messValidate: '',
        flow: '',
        commitTime: '',
        manageMaterials: false,
        partner: '',
        material: '',
        product_method: '',
        commitTimeFast: '',
        production_process: '',
    }

    componentDidMount() {

    }

    _handleChange = (value, name) => {
        const { messValidate } = this.state

        this.setState({
            [name]: value,
            messValidate: name === 'name' ? '' : messValidate
        })
    }

    _handleValidate = (sku, isPartnerGlobal) => {
        const { name, partner, material, product_method } = this.state
        let flag = true

        const checkVN = checkValidate(name)

        this.setState({
            validated: true,
            messValidate: checkVN ? 'Nhập tên không dấu và không chưa ký tự đặc biệt' : ''
        })

        if (isPartnerGlobal) {
            if (name.trim() === '' || sku.trim() === '' || partner.trim() === '' || material.trim() === '' || product_method.trim() === '' || checkVN) {
                flag = false
            }
        } else {
            if (name.trim() === '' || sku.trim() === '' || partner.trim() === '' || material.trim() === '' || checkVN) {
                flag = false
            }
        }

        return flag
    }

    _handleChangeStatus = (checked) => {
        this.setState({
            'status': checked
        })
    }

    _handleChangeManageMaterials = (checked) => {
        this.setState({
            'manageMaterials': checked
        })
    }

    _handleSubmit = (e) => {
        e.preventDefault()
        this._onSubmit()
    }

    _onSubmit = async () => {
        const { name, status, procedure, export_by, flow, commitTime, manageMaterials, partner, material, product_method, commitTimeFast, production_process } = this.state
        const { listPartner, listProductionMethods, listMaterial } = this.props
        const isPartnerGlobal = !!listPartner.length && !!listPartner.find(i => !!i._id && i._id === partner) && listPartner.find(i => !!i._id && i._id === partner).name === "MC Lab"
        const materialCode = !!listMaterial.length && listMaterial.find(i => i._id === material) && (listMaterial.find(i => i._id === material).code || '')
        const productMethodCode = !!listProductionMethods.length && listProductionMethods.find(i => i._id === product_method) && (listProductionMethods.find(i => i._id === product_method).code || '')
        const sku = (!isPartnerGlobal && !!name && !!materialCode) ? `${name}_${materialCode}` : (isPartnerGlobal && !!name && !!materialCode && !!product_method) ? `${name}_${materialCode}${productMethodCode}` : ''

        const validate = this._handleValidate(sku, isPartnerGlobal)

        if (!validate) return

        this.setState({
            loading: true,
            error: ''
        })

        try {
            const payload = {
                name,
                sku,
                is_active: status,
                procedure,
                export_by,
                flow,
                commitment_time: commitTime,
                need_manage_materials: manageMaterials,
                partner: partner,
                material,
                production_method: product_method,
                production_process,
            }

            if (commitTimeFast) payload.commitment_time_fast_production = commitTimeFast

            const { data: respons } = await addSku(payload)
            const { success, data, message: error } = respons

            if (!success) {
                throw new Error(error)
            }

            this.setState({
                loading: false,
                error: '',
                isOpen: false,
            }, () => {
                if (data.hasOwnProperty('_id')) {
                    const history = getHistory()
                    history.push(`/sku-detail/${data._id}`)
                }
                message.success('Thêm mới sản phẩm thành công')
            })
        } catch (e) {
            message.error(e.message)
            this.setState({
                loading: false,
                error: e.message
            })
        } finally {
            return this.setState({
                loading: false,
            })
        }
    }

    render() {
        const { isOpen, onToggleModal, listPartner, listMaterial, listProductionMethods, listProductionProcess } = this.props
        const {
            name,
            status,
            export_by,
            procedure,
            validated,
            messValidate,
            loading,
            error,
            flow,
            commitTime,
            manageMaterials,
            partner,
            production_process,
            material,
            product_method,
            commitTimeFast,
        } = this.state

        const isPartnerGlobal = !!listPartner.length && !!listPartner.find(i => !!i._id && i._id === partner) && listPartner.find(i => !!i._id && i._id === partner).name === "MC Lab"
        const materialCode = !!listMaterial.length && listMaterial.find(i => i._id === material) && (listMaterial.find(i => i._id === material).code || '')
        const productMethodCode = !!listProductionMethods.length && listProductionMethods.find(i => i._id === product_method) && (listProductionMethods.find(i => i._id === product_method).code || '')
        const sku = (!isPartnerGlobal && !!name && !!materialCode) ? `${name}_${materialCode}` : (isPartnerGlobal && !!name && !!materialCode && !!productMethodCode) ? `${name}_${materialCode}${productMethodCode}` : ''
        const processOptions = listProductionProcess.map(i => ({ label: i.name, value: i._id, partner: i.partner }))

        return (
            <div className="ModalEditCommitTime">
                <Modal isOpen={isOpen} toggle={onToggleModal} className='ModalEditCommitTime'>
                    <ModalHeader toggle={onToggleModal}>Thêm mới</ModalHeader>
                    <ModalBody>
                        <div className="modalBodyContent w-100">
                            <div className="Export mb-3 row w-100">
                                <label className="col-sm-3 col-form-label">Partner sản xuất <span className='text-danger'>*</span></label>
                                <div className="col-sm-9">
                                    <Select
                                        showSearch
                                        value={partner || []}
                                        name="partner"
                                        style={{ width: '100%' }}
                                        placeholder='Partner sản xuất'
                                        onChange={value => this._handleChange(value, 'partner')}
                                        filterOption={(input, option) => option.children.toLowerCase().includes((input || "").toLowerCase())}
                                    >
                                        {/* <Select.Option value="">None</Select.Option> */}
                                        <Select.Option value="THANK_CARD">Thank you card</Select.Option>
                                        {!!listPartner && listPartner.length > 0 && listPartner.map((i, index) => (
                                            <Select.Option key={index} value={i._id}>{i.name}</Select.Option>
                                        ))}
                                    </Select>
                                    {(partner.trim() === '' && validated) && (
                                        <div className="text-danger mt-1">Bắt buộc chọn partner sản xuất</div>
                                    )}
                                </div>
                            </div>
                            <div className="Export mb-3 row w-100">
                                <label className="col-sm-3 col-form-label">Quy trình sản xuất</label>
                                <div className="col-sm-9">
                                    <Select
                                        showSearch
                                        value={production_process || []}
                                        name="production_process"
                                        style={{ width: '100%' }}
                                        placeholder='Quy trình sản xuất'
                                        onChange={value => this._handleChange(value, 'production_process')}
                                        filterOption={(input, option) => option.children.toLowerCase().includes((input || "").toLowerCase())}
                                    >
                                        {/* <Select.Option value="">None</Select.Option> */}
                                        {!!processOptions && processOptions.length > 0 && processOptions.map((i, index) => (
                                            (!!i.partner && !!i.partner.id && i.partner.id === partner) &&
                                            <Select.Option key={`Process_${index}`} value={i.value}>{i.label}</Select.Option>
                                        ))}
                                    </Select>
                                </div>
                            </div>
                            <div className="NameSku mb-3 row w-100">
                                <label className="col-sm-3 col-form-label">Tên <span className='text-danger'>*</span></label>
                                <div className="col-sm-9">
                                    <Input style={{ width: "100%" }} name="name" placeholder="Nhập tên"
                                        value={name} onChange={e => this._handleChange(e.target.value, 'name')} />
                                    {(name.trim() === '' && validated) && (
                                        <div className="text-danger mt-1">Bắt buộc nhập tên</div>
                                    )}
                                    {
                                        messValidate && <div className="text-danger mt-1">{messValidate}</div>
                                    }
                                </div>
                            </div>
                            <div className="Export mb-3 row w-100">
                                <label className="col-sm-3 col-form-label">Nguyên vật liệu <span className='text-danger'>*</span></label>
                                <div className="col-sm-9">
                                    <Select
                                        showSearch
                                        name="material"
                                        value={material || []}
                                        style={{ width: '100%' }}
                                        placeholder='Nguyên vật liệu'
                                        onChange={value => this._handleChange(value, 'material')}
                                        filterOption={(input, option) => option.children.toLowerCase().includes((input || "").toLowerCase())}
                                    >
                                        {/* <Select.Option value="">None</Select.Option> */}
                                        {!!listMaterial && listMaterial.length > 0 && listMaterial.map((i, index) => (
                                            (!!i.partner && !!i.partner._id && i.partner._id === partner) && <Select.Option key={index} value={i._id}>{!!i.code ? `${i.name} - ${i.code}` : i.name}</Select.Option>
                                        ))}
                                    </Select>
                                    {(material.trim() === '' && validated) && (
                                        <div className="text-danger mt-1">Bắt buộc chọn nguyên vật liệu</div>
                                    )}
                                </div>
                            </div>
                            {isPartnerGlobal && <div className="Export mb-3 row w-100">
                                <label className="col-sm-3 col-form-label">Phương pháp sản xuất</label>
                                <div className="col-sm-9">
                                    <Select
                                        value={product_method || []}
                                        name="product_method"
                                        showSearch
                                        style={{ width: '100%' }}
                                        placeholder='Phương pháp sản xuất'
                                        onChange={value => this._handleChange(value, 'product_method')}
                                        filterOption={(input, option) => option.children.toLowerCase().includes((input || "").toLowerCase())}
                                    >
                                        {/* <Select.Option value="">None</Select.Option> */}
                                        {!!listProductionMethods && listProductionMethods.length > 0 && listProductionMethods.map((i, index) => (
                                            (!!i.partner && !!i.partner._id && i.partner._id === partner) && <Select.Option key={index} value={i._id}>{!!i.code ? `${i.name} - ${i.code}` : i.name}</Select.Option>
                                        ))}
                                    </Select>
                                    {(product_method.trim() === '' && validated) && (
                                        <div className="text-danger mt-1">Bắt buộc chọn phương pháp sản xuất</div>
                                    )}
                                </div>
                            </div>}
                            <div className="Sku mb-3 row w-100">
                                <label className="col-sm-3 col-form-label">Loại <span className='text-danger'>*</span></label>
                                <div className="col-sm-9">
                                    <Input name="sku" placeholder="Nhập loại" value={sku} style={{ width: '100%' }} />
                                    {(sku.trim() === '' && validated) && (
                                        <div className="text-danger mt-1">Bắt buộc nhập SKU</div>
                                    )}
                                </div>
                            </div>
                            <div className="Export mb-3 row w-100">
                                <label className="col-sm-3 col-form-label">Export by </label>
                                <div className="col-sm-9">
                                    <Select value={export_by || []} name="export_by" onChange={value => this._handleChange(value, 'export_by')} style={{ width: '100%' }} placeholder='Export by'>
                                        {/* <Select.Option value="">None</Select.Option> */}
                                        <Select.Option value="side">Side</Select.Option>
                                        <Select.Option value="size">Size</Select.Option>
                                    </Select>
                                </div>
                            </div>
                            <div className="Export mb-3 row w-100">
                                <label className="col-sm-3 col-form-label">Quy trình</label>
                                <div className="col-sm-9">
                                    <Select value={procedure} name="procedure" onChange={value => this._handleChange(value, 'procedure')} style={{ width: '100%' }}>
                                        <Select.Option value="2D">2D</Select.Option>
                                        <Select.Option value="3D">3D</Select.Option>
                                    </Select>
                                </div>
                            </div>
                            <div className="Export mb-3 row w-100">
                                <label className="col-sm-3 col-form-label">Luồng sản xuất</label>
                                <div className="col-sm-9">
                                    <Select value={flow || []} name="flow" onChange={value => this._handleChange(value, 'flow')} style={{ width: '100%' }} placeholder='Luồng sản xuất'>
                                        {/* <Select.Option value="">None</Select.Option> */}
                                        <Select.Option value="THANK_CARD">Thank you card</Select.Option>
                                    </Select>
                                </div>
                            </div>
                            <div className="Status mb-3 row w-100">
                                <label className="col-sm-3 col-form-label">Trạng thái </label>
                                <div className="col-sm-3 py-1">
                                    <Switch onChange={this._handleChangeStatus} checked={status}
                                        checkedChildren="Bật" unCheckedChildren="Tắt" />
                                </div>
                                <label className="col-sm-4 col-form-label">Need manage materials </label>
                                <div className="col-sm-2 py-1">
                                    <Switch onChange={this._handleChangeManageMaterials} checked={manageMaterials}
                                        checkedChildren="Bật" unCheckedChildren="Tắt" />
                                </div>
                            </div>
                            <div className="Status mb-3 row w-100">
                                <label className="col-sm-3 col-form-label">Thời gian cam kết <span className='text-danger'>*</span></label>
                                <div className="col-sm-9">
                                    <input type="number" className={'ant-input'} name="commitTime"
                                        placeholder="Nhập thời gian cam kết sản xuất" value={commitTime}
                                        onChange={e => this._handleChange(e.target.value, 'commitTime')} />
                                    {(commitTime.trim() === '' && validated) && (
                                        <div className="text-danger mt-1">Bắt buộc nhập thời gian cam kết</div>
                                    )}
                                </div>
                            </div>
                            <div className="Status mb-3 row w-100">
                                <label className="col-sm-3 col-form-label">Thời gian sản xuất nhanh</label>
                                <div className="col-sm-9">
                                    <input type="number" className={'ant-input'} name="commitTimeFast"
                                        placeholder="Nhập thời gian cam kết sản xuất nhanh" value={commitTimeFast}
                                        onChange={e => this._handleChange(e.target.value, 'commitTimeFast')} />
                                </div>
                            </div>
                            {error && <div className="text-danger mt-3">{error}</div>}
                        </div>
                    </ModalBody>
                    <ModalFooter className="d-flex justify-content-between">
                        <button className="btn btn-secondary" color="secondary" onClick={onToggleModal}>Hủy</button>
                        <button disabled={loading} onClick={this._handleSubmit} className="btn btn-primary">{loading &&
                            <i className='fa fa-spin fa-spinner mr-2' />} Thêm mới
                        </button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }

}

AddNewModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onToggleModal: PropTypes.func.isRequired
}

export default AddNewModal
